import { useState, useEffect } from 'react';
import { trackEvent } from '../utils/ga.js';
import usePrevious from './usePrevious.js';

const getDefaultSettings = (pageType) => {
    if (pageType === 'en-vn') {
        return {
            sourceLang: 'en',
            speaker: 'male_older',
            listener: 'female_younger',
            tone: 'friendly',
            dialect: 'hanoi',
            style: 'natural'
        };
    }

    return {
        sourceLang: 'ko',
        speaker: 'male_older',
        listener: 'female_younger',
        tone: 'friendly',
        dialect: 'hanoi',
        style: 'natural'
    };
};

const loadSettings = (pageType) => {
    const storageKey = `translatorSettings_${pageType}`;
    const defaultSettings = getDefaultSettings(pageType);
    try {
        const savedSettings = localStorage.getItem(storageKey);
        return savedSettings ? { ...defaultSettings, ...JSON.parse(savedSettings) } : defaultSettings;
    } catch (e) {
        console.error("Failed to parse settings from localStorage", e);
        return defaultSettings;
    }
};


export const useSettings = (pageType) => {
    const [settings, setSettings] = useState(() => loadSettings(pageType));
    const prevSettings = usePrevious(settings);
    const storageKey = `translatorSettings_${pageType}`;

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(settings));

        if (prevSettings && JSON.stringify(prevSettings) !== JSON.stringify(settings)) {
            for (const key in settings) {
                if (settings[key] !== prevSettings[key]) {
                    trackEvent('change_setting', {
                        setting_type: key,
                        setting_value: settings[key]
                    });
                }
            }
        }
    }, [settings, prevSettings, storageKey]);

    return [settings, setSettings];
};
